<template>
  <article class="detail">
    <GridContainer>
      <GridColumn :size="6">
        <figure class="detail__canvas">
          <span class="detail__canvas-sizer"></span>
          <div class="detail__canvas-wrapper">
            <canvas id="product-preview"></canvas>
          </div>
        </figure>
      </GridColumn>
      <GridColumn :size="6">
        <div class="detail__data">
          <header class="detail__info">
            <h2 class="detail__title">Pink heart Keychain</h2>
            <time class="detail__date" datetime="">13/10/2020</time>
          </header>
          <div class="detail__preview">
            <fieldset v-for="(control, index) in textControl" :key="index">
              <Input :name="'field_input_' + control.id" :id="'field_input_' + control.id" :label="'Line ' + (index + 1)" @onChange="value => onChangeTextControl(control.id, value)" />
              <Select :name="'field_select_' + control.id" :id="'field_select_' + control.id" value="1" :label="'Line ' + (index + 1) + ' font'" :options="control.fonts" @onChange="value => onChangeSelectControl(control.id, value)" />
            </fieldset>
          </div>
        </div>
      </GridColumn>
    </GridContainer>
    <GridContainer>
      <GridColumn :size="12" class="detail__actions">
        <Button format="link" href="/" instance="invert" width="medium">Back</Button>
        <Button format="button" instance="secondary" width="medium">Save</Button>
      </GridColumn>
    </GridContainer>
  </article>
</template>

<script>
import { defineComponent } from 'vue'
import GridContainer from '@/components/GridContainer.vue'
import GridColumn from '@/components/GridColumn.vue'
import Button from '@/components/AtomButton.vue'
import Input from '@/components/FormInput.vue'
import Select from '@/components/FormSelect.vue'
import { getFontName } from '@/utils'

export default defineComponent({
  components: {
    GridColumn,
    GridContainer,
    Button,
    Input,
    Select
  },
  props: {
    item: {}
  },
  data () {
    return {
      engraver: {},
      product_id: String,
      textControl: []
    }
  },
  methods: {
    onChangeTextControl (id, value) {
      this.engraver.setText(id, value)
    },
    onChangeSelectControl (id, value) {
      this.engraver.setFont(id, parseInt(value))
    },
    loadScript () {
      const self = this
      if (document.getElementById('customily')) {
        self.engraver = window.engraver
        self.init()
      } else {
        const script = document.createElement('script')
        script.onload = () => {
          self.engraver = window.engraver
          self.init()
        }
        script.id = 'customily'
        script.async = true
        script.src = 'https://cdn.customily.com/customily.js'
        document.head.appendChild(script)
      }
    },
    parseFonts (fonts) {
      const FontsArr = JSON.parse(fonts)
      return FontsArr.map(fontPath => ({
        value: fontPath[0],
        text: getFontName(fontPath[1])
      }))
    },
    init () {
      const self = this
      this.engraver.init('product-preview')
      this.engraver.setProduct(this.productId).then(() => {
        this.engraver.currentProduct.preview.textsPreview.forEach(text => {
          self.textControl.push({
            id: text.id,
            fonts: self.parseFonts(text.fontsMap)
          })
        })
      })
    }
  },
  mounted () {
    this.productId = this.$route.params.id
    this.loadScript()
  }
})
</script>

<style lang="scss">
  .detail {
    &__canvas {
      position: relative;

      &-sizer {
        width: 100%;
        height: 0;
        padding-top: 100%;
        display: block;
        background-color: white;
      }
      &-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
    &__data {
      background-color: #ebebeb;
      height: 100%;
      padding: em(20) em(15);
    }
    &__info {
      display: flex;
      justify-content: space-between;
      margin-bottom: em(30);
    }
    &__title {
      font-weight: normal;
      font-size: em(20);
      line-height: 1.2;
    }
    &__date {
      font-size: em(16);
      color: rgb(103,103,103);
    }
    &__actions {
      display: flex;
      justify-content: space-between;
      margin-top: em(50);
    }
  }
</style>
